import React, { useEffect, useState } from "react";

import useGroups from "./hooks/useGroups";

import AdminPageHeader from "../widgets/PageHeader";
import { Button } from "antd";
import { TransitionedRoutePage } from "../admin.style";
import AdminGroupTable from "./widgets/GroupTable";
import GroupCreateModal from "./widgets/GroupCreateModal";
import LoadingIndicator from "common/components/LoadingIndicator";

function GroupAdmin() {
	const { groups, error, status, fetchGroups } = useGroups();
	const [showCreateModal, setShowCreateModal] = useState<boolean>(false);

	useEffect(() => {
		if (!groups.length) fetchGroups();

		// eslint-disable-next-line
	}, []);

	return (
		<TransitionedRoutePage>
			<AdminPageHeader
				page="Groups"
				indicator={<LoadingIndicator loading={[status]} />}
			>
				<Button onClick={() => setShowCreateModal(!!!showCreateModal)}>
					Add New
				</Button>
			</AdminPageHeader>
			{error && <p className="error">{error}</p>}
			<AdminGroupTable groups={groups} isLoading={status === "loading"} />
			<GroupCreateModal
				visible={!!showCreateModal}
				closeModal={() => setShowCreateModal(false)}
			/>
		</TransitionedRoutePage>
	);
}

export default GroupAdmin;
